<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle"></div>
          <el-tabs
            class="elTabs"
            v-model="activeName"
            @tab-click="handleClick"
            v-if="initDatas"
          >
            <el-tab-pane label="企业列表" name="0">
              <enterprise-list></enterprise-list>
            </el-tab-pane>
            <el-tab-pane label="企业分类" name="1">
              <enterprise-classify></enterprise-classify>
            </el-tab-pane>
            <el-tab-pane label="待审核" name="2">
              <enterprise-review-list></enterprise-review-list>
            </el-tab-pane>
          </el-tabs>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import enterpriseList from "@/components/enterprise/enterpriseList";
import enterpriseClassify from "@/components/enterprise/enterpriseClassify";
import enterpriseReviewList from "@/components/enterprise/enterpriseReviewList";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    enterpriseList,
    enterpriseClassify,
    enterpriseReviewList,
  },
  // beforeRouteLeave(to, from, next) {
  //   console.log(to)
  //   from.meta.keepAlive = to.path == '/wxapp/enterprise_add'
  //   next()
  // },
  data() {
    return {
      initDatas: false,
      meunItem: null,
      meunTitle: "",
      headTitle: "校友会名称",
      activeName: "0",
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = meunItem.name;
      this.headTitle = this.$route.query.title;
      this.initDatas = true;
      // if (this.$route.query.activeName) {
      //   this.activeName = this.$route.query.activeName;
      // }
    },
    handleClick(tab, event) {
      // localStorage.setItem(this.$route.path, tab.name)
    },
  },
};
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -40px;
  margin-left: -20px;
  margin-right: -20px;
}
.elTabs {
  margin-top: -40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/enterprise.vue